import type { OrderType } from '@klareospace/pharos-lib-types';

import { useOrderTypes } from './use-order-types';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface UseOrderTypesPageReturn {
  error: Error | null;
  isLoading: boolean;
  orderTypes: OrderType[];
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useOrderTypesPage(options?: { enabled?: boolean }): UseOrderTypesPageReturn {
  const { data, error, isLoading } = useOrderTypes({
    enabled: options?.enabled,
    statuses: ['active'],
  });

  return {
    error: error ?? null,
    isLoading,
    orderTypes: data?.items ?? [],
  };
}
